import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'; 
import axios from 'axios';
import { NavLink, Link } from 'react-router-dom';
import { BsSend } from "react-icons/bs";
import { MdHome } from "react-icons/md";
import { MdLocalShipping } from "react-icons/md";
import { MdPayments } from "react-icons/md";
import { TbPremiumRights } from "react-icons/tb";
import { MdAddIcCall } from "react-icons/md";
import { TbWorldCheck } from "react-icons/tb";
import { FaQuestionCircle } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaWhatsappSquare } from "react-icons/fa";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FaAppStoreIos } from "react-icons/fa6";

const Footer = () => {
  const handleNavigation = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.bootstrap131.appcampusify",
      "_blank"
    );
  };
  const [categories, setCategories]= useState([]);


  const API_KEY=[
   {APARTMENTS_API_KEY : 'https://campusbuy-backend-nkmx.onrender.com/getproducts?category=Apartments'},
  {PHONES_API_KEY :'https://campusbuy-backend-nkmx.onrender.com/getproducts?category=Phones'},
  {LAPTOPS_API_KEY: 'https://campusbuy-backend-nkmx.onrender.com/getproducts?category=Laptops'},
  {BAGS_API_KEY: 'https://campusbuy-backend-nkmx.onrender.com/getproducts?category=Bags'},
  {ACCESSORIES_API_KEY: 'https://campusbuy-backend-nkmx.onrender.com/getproducts?category=Accessories'},
  {HAIRS_AND_WIGS_API_KEY: 'https://campusbuy-backend-nkmx.onrender.com/getproducts?category=Hairs and Wigs'},
  {CLOTHES_API_KEY: 'https://campusbuy-backend-nkmx.onrender.com/getproducts?category=Clothes'},
  ]

  const dispatch = useDispatch()
 const getCategory = (category)=> dispatch({ type:'GET_CATEGORY', category : category })
 const returnedCategory= useSelector(state => state.category.category)





   const fetchCategories = async (categoryApi) => {
     try {
       const response = await axios.get(categoryApi);
       setCategories(response.data);
       getCategory(response.data); // Pass the updated data directly
     } catch (error) {
       console.error('Error fetching categories:', error);
       // Handle error as needed
     }
   };
 



  const [scrollDirection, setScrollDirection] = useState("up");
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  const handleScroll = () => {
    const currentScrollPos = document.documentElement.scrollTop;

    if (currentScrollPos > prevScrollPos) {
      setScrollDirection("down");
    } else {
      setScrollDirection("up");
    }

    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos]);


  return (
    <>
    <footer className='py-4 max-lg:hidden'>
      <div className='container-xxl'>
        <div className='row p-4 m-4'>
          <div className='col-5'>
            <div className='footer-top-data d-flex  align-items-center justify-content-center '>
              <BsSend className= 'text-white sender'/>
              <h4 className='text-white text-xl'>Sign Up for Newsletter</h4>
            </div>
          </div>
          <div className='col-6'>
            <form className='bg-white footer-top-newsletter d-flex  align-items-center '>
              <input className='input' placeholder='Enter Your Email' type='text' />
              <button><strong>Subscribe</strong></button>
            </form>
          </div>
        </div>
      </div>
    </footer>
    <footer className='py-4 text-white p-4 max-lg:hidden'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-3 flex flex-col gap-2'>
            <h4 className='text-2xl'>Contact Us</h4>
            <div className=' flex flex-col gap-2'>
              <h6 className='text-xl'>Campusbuy Office</h6>
              <p>37b Sabibatu estate, Inside Otubu Estate, Abule-ado, Satellite-town, Lagos, Nigeria. </p>
              <p>+2348164910957, +2347042380116, +2349069412463, +2348188317279</p>
              <p>campusify2@gmail.com.com, louisjoseph131@gmail.com, udegbueconfidence@gmail.com</p>
            <div className='social-media-links d-flex align-items-center'>
             <Link className='navbar-react-icons'><FaFacebook /></Link>
             <Link className='navbar-react-icons'><FaInstagramSquare /></Link>
             <Link className='navbar-react-icons'><FaXTwitter /></Link>
             <Link className='navbar-react-icons'><FaLinkedin /></Link>
             <Link className='navbar-react-icons'><FaWhatsappSquare /></Link>
            </div>
            </div>
          </div>
          <div className='col-2 flex flex-col gap-2'>
          <h4 className='text-2xl'>Our Policy</h4>
            <div className='flex flex-col gap-2'>
            <p> <NavLink className='text-white' to = '/privacy'>Privacy policy</NavLink></p>
             <p> <Link className='text-white' href = '#'>Shipping policy</Link></p>
             <p> <Link className='text-white' href = '#'>Payment policy</Link></p>
             <p> <Link className='text-white' href = '#'>Cookie policy</Link></p>
             <p> <Link className='text-white' href = '#'>Copyright Infringement policy</Link></p>
             <p> <Link className='text-white' href = '#'>Terms of Service </Link></p>
             <p> <Link className='text-white' href = '#'>Blog </Link></p>
          </div>
          </div>
          <div className='col-2 flex flex-col gap-2'>
          <h4 className='text-2xl'>Account</h4>
            <div className='flex flex-col gap-2'>
              <p><NavLink className='text-white' href = '#'>Search</NavLink></p>
              <p><NavLink className='text-white' href = '#'>About Us</NavLink></p>
              <p><NavLink to='/faqs' className='text-white' href = '#'>FAQs</NavLink></p>
              <p><NavLink className='text-white' href = '#'>Contact</NavLink></p>
              <p><NavLink className='text-white' href = '#'>Safety Tips</NavLink></p>
          </div>
          </div>
          <div className='col-2 flex flex-col gap-2'>
          <h4 className='text-2xl'>Quick Links</h4>
            <div className='flex flex-col gap-2'>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[0].APARTMENTS_API_KEY)  
              }} className='text-white' href = '#'>Apartments</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[1].ACCESSORIES_API_KEY)  
              }} className='text-white' href = '#'>Accessories</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[2].PHONES_API_KEY)  
              }} className='text-white' href = '#'>Phones</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[3].BAGS_API_KEY)  
              }} className='text-white' href = '#'>Bags</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[4].CLOTHES_API_KEY)  
              }} className='text-white' href = '#'>Clothes</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[5].LAPTOPS_API_KEY)  
              }} className='text-white' href = '#'>Laptops</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[6].HAIRS_AND_WIGS_API_KEY)  
              }} className='text-white' href = '#'>Hair and Wigs</NavLink></p>
          </div>
          </div>
          <div className='col-3 flex flex-col gap-2'>
          <h4 className='text-2xl'>Our App</h4>
            <div>
              <p>Download our app for convenience in finding products, contacting buyers and getting daily notifications on your favorite products.</p>
              <div className='social-media-links d-flex align-items-center'>
             <Link className='navbar-react-icons'><FaAppStoreIos /></Link>
             <Link onClick={handleNavigation} className='navbar-react-icons'><IoLogoGooglePlaystore /></Link>
            </div>
          </div>
          </div>
        </div>
      </div>
    </footer>
    <footer className='py-4 max-lg:hidden'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <p className='text-center mb-0 text-white'>
              &copy; {new Date().getFullYear()}; Powered by Campusbuy.Inc(" ")
            </p>
          </div>
        </div>
      </div>
    </footer>
    <footer className='py-4 hidden max-lg:block '>
      <div className='container'>
        <div className='row p-2 m-2'>
          <div className='col-5'>
            <div className='footer-top-data d-flex  align-items-center justify-content-center '>
              <BsSend className= 'text-white sender'/>
              <h4 className='text-white text-[10px]'>Sign Up for Newsletter</h4>
            </div>
          </div>
          <div className='col-6 text-[8px]'>
            <form className='bg-white footer-top-newsletter d-flex  align-items-center '>
              <input className='input' placeholder='Enter Your Email' type='text' />
              <button><strong>Subscribe</strong></button>
            </form>
          </div>
        </div>
      </div>
    </footer>
    <footer className='py-4 hidden max-lg:block text-white p-2 '>
      <div className='container'>
        <div className='row'>
          <div className='col-3 flex flex-col gap-1 text-[6px]'>
            <h4 className='text-[10px]'>Contact Us</h4>
            <div className=' flex flex-col gap-1'>
              <h6 className='text-[10px]'>Campusbuy Office</h6>
              <p>37b Sabibatu estate, Inside Otubu Estate, Abule-ado, Satellite-town, Lagos, Nigeria. </p>
              <p>+2348164910957, +2347042380116, +2349069412463, +2348188317279</p>
              <p>campusify2@gmail.com.com</p>
              <p>louisjoseph131@gmail.com</p>
              <p>udegbueconfidence@gmail.com</p>
            <div className='social-media-links d-flex align-items-center'>
             <Link className='navbar-react-icons'><FaFacebook /></Link>
             <Link className='navbar-react-icons'><FaInstagramSquare /></Link>
             <Link className='navbar-react-icons'><FaXTwitter /></Link>
             <Link className='navbar-react-icons'><FaLinkedin /></Link>
             <Link className='navbar-react-icons'><FaWhatsappSquare /></Link>
            </div>
            </div>
          </div>
          <div className='col-2 flex flex-col gap-1'>
          <h4 className='text-[10px]'>Our Policy</h4>
            <div className='flex flex-col gap-1 text-[8px]'>
             <p> <NavLink className='text-white' to = '/privacy'>Privacy policy</NavLink></p>
             <p> <Link className='text-white' href = '#'>Shipping policy</Link></p>
             <p> <Link className='text-white' href = '#'>Payment policy</Link></p>
             <p> <Link className='text-white' href = '#'>Cookie policy</Link></p>
             <p> <Link className='text-white' href = '#'>Copyright Infringement policy</Link></p>
             <p> <Link className='text-white' href = '#'>Terms of Service </Link></p>
             <p> <Link className='text-white' href = '#'>Blog </Link></p>
          </div>
          </div>
          <div className='col-2 flex flex-col gap-1'>
          <h4 className='text-[10px]'>Account</h4>
            <div className='flex flex-col gap-1 text-[8px]'>
              <p><NavLink className='text-white' href = '#'>Search</NavLink></p>
              <p><NavLink className='text-white' href = '#'>About Us</NavLink></p>
              <p><NavLink to='/faqs' className='text-white' href = '#'>FAQs</NavLink></p>
              <p><NavLink className='text-white' href = '#'>Contact</NavLink></p>
              <p><NavLink className='text-white' href = '#'>Safety Tips</NavLink></p>
          </div>
          </div>
          <div className='col-2 flex flex-col gap-1'>
          <h4 className='text-[10px]'>Quick Links</h4>
            <div className='flex flex-col gap-1 text-[8px]'>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[0].APARTMENTS_API_KEY)  
              }} className='text-white' href = '#'>Apartments</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[1].ACCESSORIES_API_KEY)  
              }} className='text-white' href = '#'>Accessories</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[2].PHONES_API_KEY)  
              }} className='text-white' href = '#'>Phones</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[3].BAGS_API_KEY)  
              }} className='text-white' href = '#'>Bags</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[4].CLOTHES_API_KEY)  
              }} className='text-white' href = '#'>Clothes</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[5].LAPTOPS_API_KEY)  
              }} className='text-white' href = '#'>Laptops</NavLink></p>
              <p><NavLink onClick={()=>{fetchCategories(API_KEY[6].HAIRS_AND_WIGS_API_KEY)  
              }} className='text-white' href = '#'>Hair and Wigs</NavLink></p>
          </div>
          </div>
          <div className='col-3 flex flex-col gap-1'>
          <h4 className='text-[10px]'>Our App</h4>
            <div className='text-[8px]'>
              <p>Download our app for convenience in finding products, contacting buyers and getting daily notifications on your favorite products.</p>
              <div className='social-media-links d-flex align-items-center'>
             <Link className='navbar-react-icons'><FaAppStoreIos /></Link>
             <Link onClick={handleNavigation} className='navbar-react-icons'><IoLogoGooglePlaystore /></Link>
            </div>
          </div>
          </div>
        </div>
      </div>
    </footer>
    <footer className='py-4 hidden max-lg:block '>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <p className='text-center mb-0 text-white text-[8px]'>
              &copy; {new Date().getFullYear()}; Powered by Campusbuy.Inc(" ")
            </p>
          </div>
        </div>
      </div>
    </footer>
    <footer className={`mobile-footer w-[100%] hidden max-lg:block bg-[#232f3e] shadow-md shadow-[#3b4149] ${
          scrollDirection === "down" ? "scrolled-down" : "scrolled-up"
        }`}>

    <div className="upper-mobile-links flex gap-2 m-2 py-1  justify-between items-center">
            <div><NavLink to="/" className='flex  flex-col gap-1 justify-center items-center'><MdHome className='mobile-footer-react-icons'/>  <span  className='text-white text-[10px]'>  Home</span></NavLink></div>           
            <div><NavLink to= "/about" className='flex  flex-col gap-1 justify-center items-center'><TbWorldCheck className='mobile-footer-react-icons'/>  <span  className='text-white text-[10px]'>  About</span></NavLink></div>
            <div><NavLink to="/faqs" className='flex  flex-col gap-1 justify-center items-center'><FaQuestionCircle className='mobile-footer-react-icons'/>  <span  className='text-white text-[10px]'> Faqs</span></NavLink></div>
            <div><NavLink to='/contact' className='flex  flex-col gap-1 justify-center items-center'><MdAddIcCall  className='mobile-footer-react-icons'/>  <span  className='text-white text-[10px]'>  Contact</span></NavLink></div>

            </div>
    </footer>
    </>
  )
}

export default Footer